import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App.jsx";
import logger from "./utils/logger";

const bootstrapShell = document.getElementById("app-bootstrap-shell");
if (bootstrapShell) {
  bootstrapShell.remove();
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then(
      (registration) => {
        logger.info("ServiceWorker registration successful with scope: ", registration.scope);
      },
      (error) => {
        logger.info("ServiceWorker registration failed: ", error);
      }
    );
  });
}

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
